module.exports = __webpack_public_path__ + "img/gmsyt4.351a5f8f.png";